import { useState, useRef, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';

//Components
import { Button, Input, Form, Select } from "@gpstrackit/react-controls";
import { Typography } from '@mui/material';
//Chars
import ChartBar from 'Modules/dashboard/views/.components/chart/.components/bar';
//Actions
import { sizeDashboardPanelCreateEditModal, searchEntityRequest } from 'Redux/actions'

const backgroundColor = [
    '#66BB6A',
    '#03A9F4',
    '#1D2734',
    '#018F82',
    '#13B2A3',
    '#37AFCC',
    '#00C6FC',
    '#00ACFB',
    '#008CDD',
    '#0059A0',
    '#2F4F6C',
    '#6685A7',
    '#825C8D',
    '#812F6F',
    '#006014',
    '#007F25',
    '#40BE60',
    '#69C97D',
    '#A9EAB3',
    '#ECB651',
    '#EA6947',
    '#D13C3C',
    '#AC2A47',
    '#C23E68',
    '#E97694',
]

const CreateEditVidFleetFirmware = (props) => {
    const { onSubmit, handleClose } = props;
    const { messages } = useIntl();

    const dispatch = useDispatch();
    const editCreateDashboardGadgets = useRef();

    //Local States
    const [formData, setFormData] = useState({});
    const [dataChart, setDataChart] = useState({});
    const [deviceModelList, setDeviceModelList] = useState([]);

    const optionsFrecuency = [
        { id: 300, name: messages['dashboard_gadget_five_minutes'] },
        { id: 900, name: messages['dashboard_gadget_fifteen_minutes'] },
        { id: 1800, name: messages['dashboard_gadget_thirty_minutes'] },
        { id: 3600, name: messages['dashboard_gadget_one_hour'] },
        { id: 7200, name: messages['dashboard_gadget_two_hour'] }
    ];

    const {
        loadingCreateEdit,
        gadGet
    } = useSelector((state) => state.dashboardPanelMainRedux);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);

    const validateData = () => {
         onSubmit({
            ...formData,
            deviceModelId: formData.deviceModel.id,
            refreshSeconds: formData.refreshSeconds.id,
            name: formData.name.trim(),
            type: 'VidFleetFirmware',
            chartType: 'column'
         })
    }

    let dataPreview = {
        labels: ["456.456.34.23"],
        data: [56],
        datasets: [{
            data: [56],
            backgroundColor: backgroundColor,
            label: ["456.456.34.23"],
            hoverOffset: 4
        }],
        type: 'VidFleetFirmware',
        unit: 'Total',
        subTitle: `${messages['dashboard_device_model']}`
    }

    const chartData = useMemo(() => {
        return <ChartBar data={dataPreview} />;
    }, []);

    useEffect(() => {
        dispatch(sizeDashboardPanelCreateEditModal('medium'));
    }, [])

    useEffect(() => {
        if (gadGet?.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setFormData({
                ...formData,
                name: gadGet.name,
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0],
                deviceModel: settings?.deviceModel,
                chartType: 'column',
            })
        } else {
            setFormData({ ...formData, chartType: 'column' });
        }
        dispatch(searchEntityRequest({ key: "deviceModels" }));
        dispatch(searchEntityRequest({ key: "manufacturers" }));
    }, [open, gadGet])

    useEffect(() => {
        if(manufacturers && manufacturers.length){
            let vidFleet = manufacturers.find((item) => item.name === 'VidFleet')
            if(vidFleet.id){
                let newDeviceModels = deviceModels.filter((item) => item.manufacturerId === vidFleet.id)
                setDeviceModelList(newDeviceModels)
            }
        }
    },[manufacturers, deviceModels])

    return (
        <div className="create-edit-container">
            <div className="create-edit-preview" >
                <div className="create-edit-preview-chart" >
                    <Typography className="create-edit-preview-label" variant="subtitle1">
                        {messages['dashboard_gadget_preview']}
                    </Typography>
                    {chartData}
                </div>
            </div>
            <div className="create-edit-separator" >
                <Form
                    ref={editCreateDashboardGadgets}
                    onSubmit={() => {
                        return true
                    }}
                    onValidSubmit={validateData}
                    style={{ height: '100%' }}>
                    <div>
                        <div>
                            <Input
                                id="name"
                                value={formData.name || ""}
                                onChange={(value) => setFormData({ ...formData, name: value })}
                                minLength={1}
                                maxLength={40}
                                label={messages['dashboard_gadget_title']}
                                placeholder={messages['dashboard_gadget_title']}
                                type="text"
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item">
                            <Select
                                id="devicemodel"
                                label="Device Model"
                                placeholder="Device Model"
                                options={deviceModelList || []}
                                textField="name"
                                valueField="id"
                                value={formData.deviceModel}
                                onChange={(value) => setFormData({ ...formData, deviceModel: value })}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item">
                            <Select
                                id="refreshSeconds"
                                label={messages['dashboard_gadget_frequency_refresh']}
                                placeholder={messages['dashboard_gadget_frequency_refresh']}
                                options={optionsFrecuency}
                                textField="name"
                                valueField="id"
                                value={formData.refreshSeconds}
                                onChange={(value) => setFormData({ ...formData, refreshSeconds: value })}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    </div>
                </Form>
                <div className="create-edit-buttons" style={{ width: '100%', backgroundColor: '#fff' }}>
                    <Button
                        disabled={loadingCreateEdit}
                        className="btn-cancel"
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            dispatch(sizeDashboardPanelCreateEditModal('small'));
                            handleClose();
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        disabled={loadingCreateEdit}
                        onClick={(e) => editCreateDashboardGadgets.current.submit()}
                        className="btn-dark-blue"
                    >
                        {messages['save']}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CreateEditVidFleetFirmware